import { render } from "./BuyNow.vue?vue&type=template&id=72442763&scoped=true"
import script from "./BuyNow.vue?vue&type=script&lang=js"
export * from "./BuyNow.vue?vue&type=script&lang=js"

import "./BuyNow.vue?vue&type=style&index=0&id=72442763&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72442763"]])

export default __exports__